<template>
    <form v-if="employee_extended && hasAccess" class="pt-4">
        <top-nav-bar goto="/?page=profile"></top-nav-bar>

        <div class="pb-8 clearfix">
            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">
                    {{trans('crewman::details.title.osm_aviation_details')}}
                </span>
            </h4>

            <div class="flex flex-col sm:flex-row">
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="formatted_id" :label="trans('crewman::details.state.osm_aviation_id')">
                        <input disabled type="text" class="input" :value="employee_extended.formatted_id">
                    </form-group>
                </div>
                <div class="flex-1 px-4 pb-0 sm:pb-4">
                    <form-group name="seniority_date"
                                :label="trans('crewman::details.state.osm_aviation_seniority_date')">
                        <input disabled type="text" class="input"
                               :value="formatDate(employee_extended.seniority_date, 'DD.MM.YYYY')">
                    </form-group>
                </div>
            </div>
            <h4 class="mb-10 pl-4 text-lg">
                <span class="pb-2 border-b-4 border-blue">
                    {{trans('crewman::details.title.client_details')}}
                </span>
            </h4>

            <template v-for="clientDetail in employee_extended.client_details">

                <div class="flex flex-col sm:flex-row">
                    <div class="flex-1 px-4 pb-0 sm:pb-4">
                        <form-group class="mb-4" name="client_details.client"
                                    :label="trans('crewman::details.state.client')">
                            <input disabled type="text" class="input" :value="clientDetail.client">
                        </form-group>
                    </div>
                    <div class="flex-1 px-4 pb-0 sm:pb-4">
                        <form-group class="mb-4" name="client_details.client_details_id"
                                    :label="trans('crewman::details.state.id')">
                            <input disabled type="text" class="input" :value="clientDetail.client_details_id">
                        </form-group>
                    </div>
                </div>

                <div class="flex flex-col sm:flex-row mb-6">
                    <div class="flex-1 px-4 pb-0 sm:pb-4">
                        <form-group class="mb-4" name="client_details.seniority_date"
                                    :label="trans('crewman::details.state.client_seniority_date')">
                            <input disabled type="text" class="input"
                                   :value="formatDate(clientDetail.seniority_date, 'DD.MM.YYYY')">
                        </form-group>
                    </div>
                    <div class="flex-1 px-4 pb-0 sm:pb-4">
                        <form-group class="mb-4" name="client_details.bond_start"
                                    :label="trans('crewman::details.state.bond_start')">
                            <input disabled type="text" class="input"
                                   :value="formatDate(clientDetail.bond_start, 'DD.MM.YYYY')">
                        </form-group>
                    </div>
                    <div class="flex-1 px-4 pb-0 sm:pb-4">
                        <form-group class="mb-4" name="client_details.bond_end"
                                    :label="trans('crewman::details.state.bond_end')">
                            <input disabled type="text" class="input"
                                   :value="formatDate(clientDetail.bond_end, 'DD.MM.YYYY')">
                        </form-group>
                    </div>
                </div>

            </template>

            <div class="block md:inline-flex md:float-right px-4">
                <button class="btn btn--colored__green w-full disabled" disabled="disabled" type="submit">
                    <i class="fal fa-check"></i>
                    {{ trans('crewman::common.button.save') }}
                </button>
            </div>
        </div>
    </form>
</template>

<script>
    import {mapState} from 'vuex';
    import InteractsWithDates from '@/mixins/InteractsWithDates'
    import CanAccessView from "../mixins/CanAccessView";

    export default {
        mixins: [InteractsWithDates, CanAccessView],

        computed: {
            ...mapState(['employee_extended']),
        },
    }
</script>
